import { cn } from '@/shared/lib/utils';

/** Select 트리거와 같은 모양의 필드형 버튼 스타일 (FilterButton 등에서 재사용) */
export const fieldTriggerClassName = cn(
  'group flex h-12 shrink-0 cursor-pointer items-center justify-between gap-3 rounded-16 border-[1.5px] border-line-grey bg-surface-white px-3 text-left outline-none',
  'focus-visible:border-fg-accent data-[disabled]:cursor-default data-[disabled]:opacity-50',
);
